import MapView from "./views/MapView";

const App = () => {
  return (
    <div style={{ height: '100vh', width: '100vw', position: 'relative', overflow: 'hidden' }}>
      <MapView />
    </div>
  );
};

export default App;
